"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgUpdateUser = function SvgUpdateUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M7.93 23.398V17.7L12 20.551Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M2.227 16.477c0-.797.687-1.532 1.84-2.133.097-.399.226-.77.382-1.114-2.355.899-3.847 2.2-3.847 3.657 0 2.336 3.836 4.289 8.957 4.77v-1.634c-4.215-.41-7.332-1.84-7.332-3.546Zm17.32-3.247c.16.34.285.715.383 1.114 1.156.601 1.843 1.336 1.843 2.133 0 1.816-3.523 3.32-8.144 3.613v1.625c5.523-.34 9.77-2.367 9.77-4.828 0-1.457-1.493-2.762-3.852-3.657Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#333",
      fillOpacity: 1
    },
    d: "M5.71 15.898A4.504 4.504 0 0 1 10.2 11.7h3.6a4.504 4.504 0 0 1 4.49 4.2Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M13.8 12a4.208 4.208 0 0 1 4.157 3.602H6.043A4.205 4.205 0 0 1 10.199 12h3.602m0-.602h-3.602A4.805 4.805 0 0 0 5.4 16.2h13.203c0-2.648-2.153-4.8-4.801-4.8Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M12 13.047c-1.602 0-2.027-.879-2.102-1.059v-2.09h4.204v2.09c-.075.184-.5 1.059-2.102 1.059Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M13.8 10.2v1.722c-.1.207-.51.824-1.8.824-1.3 0-1.707-.629-1.8-.82v-1.727h3.6m.598-.597H9.602v2.437s.375 1.309 2.398 1.309 2.398-1.309 2.398-1.309Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M12 11.102a.81.81 0 0 1-.625-.301l-.063-.074-.097-.024A3.292 3.292 0 0 1 8.699 7.5V4.348a1.42 1.42 0 0 1 1.418-1.418h3.766A1.42 1.42 0 0 1 15.3 4.348V7.5a3.292 3.292 0 0 1-2.516 3.203l-.094.024-.062.074c-.16.191-.39.3-.629.3Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M13.883 3.23c.617 0 1.117.5 1.117 1.118V7.5a2.992 2.992 0 0 1-2.285 2.91l-.192.047-.128.152a.51.51 0 0 1-.395.192.51.51 0 0 1-.395-.192l-.128-.152-.192-.047A2.992 2.992 0 0 1 9 7.5V4.348c0-.618.5-1.118 1.117-1.118h3.766m0-.601h-3.766c-.949 0-1.719.77-1.719 1.719V7.5a3.598 3.598 0 0 0 2.747 3.492 1.104 1.104 0 0 0 1.71 0A3.598 3.598 0 0 0 15.602 7.5V4.348c0-.95-.77-1.72-1.72-1.72Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#333",
      fillOpacity: 1
    },
    d: "M15.691 11.238c-.824 0-1.68-.613-2.09-.953.415-.387 1.098-1.254 1.098-2.738v-.984c0-1.086-.566-2.114-.59-2.157l-.199-.355-.281.293c-.008.011-.934.957-2.711 1.363-1.055.238-1.617 1.191-1.617 1.79 0 1.51.613 2.366.98 2.737-.355.352-1.136 1.004-1.972 1.004-.758 0-1.434-.367-1.805-.62.422-.352 1.082-1.06 1.082-2.048 0-.414-.02-.73-.04-1.066-.023-.379-.046-.77-.046-1.367C7.5 2.699 9.648.898 11.77.898c1.71 0 2.257 1.196 2.265 1.207l.078.18h.196c1.812 0 2.191 1.844 2.191 3.39 0 .63-.05 1.157-.098 1.669-.047.476-.086.93-.086 1.426 0 .84.622 1.316 1.168 1.543-.34.37-.984.925-1.793.925Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M11.77 1.2c1.484 0 1.972.991 1.988 1.027l.16.359h.39c1.255 0 1.891 1.039 1.891 3.09 0 .613-.047 1.136-.094 1.64-.046.485-.09.942-.09 1.454 0 .789.458 1.308.962 1.617-.32.277-.77.55-1.286.55-.566 0-1.199-.359-1.644-.683.433-.504.953-1.379.953-2.707v-.984c0-1.16-.605-2.258-.629-2.301l-.398-.703-.559.578c-.008.011-.883.894-2.562 1.277C9.645 5.688 9 6.801 9 7.496c0 1.356.473 2.227.863 2.715-.37.32-.957.726-1.554.726-.496 0-.965-.183-1.313-.37.426-.434.89-1.114.89-1.997 0-.425-.019-.746-.038-1.086A19.445 19.445 0 0 1 7.8 6.137c0-3.242 1.996-4.938 3.969-4.938m0-.597C9.55.602 7.2 2.488 7.2 6.137c0 1.133.085 1.562.085 2.433C7.285 9.844 6 10.617 6 10.617s1.04.922 2.309.922c1.289 0 2.406-1.32 2.406-1.32s-1.113-.75-1.113-2.723c0-.426.445-1.285 1.382-1.496 1.903-.434 2.864-1.445 2.864-1.445s.55.988.55 2.008v.984c0 1.933-1.257 2.73-1.257 2.73s1.27 1.262 2.55 1.262c1.387 0 2.309-1.387 2.309-1.387s-1.387-.246-1.387-1.382c0-1.012.188-1.872.188-3.094 0-2.66-1.07-3.692-2.492-3.692 0 0-.614-1.382-2.54-1.382Zm0 0"
  }));
};
var _default = SvgUpdateUser;
exports["default"] = _default;